module.exports = __webpack_public_path__ + "static/media/faq_(14).00d382c3.gif";